import React, { useState } from "react";
import { PiXFill } from "react-icons/pi";
import { postApi } from "../../../services/api/globalApi";
import {
  errorMessage,
  successMessage,
} from "../../../utils/toastify-message/ToastifyMessage";
import AssignPermissionSelect from "../inputs/AssignPermissionSelect";

const { forwardRef, useRef, useImperativeHandle } = React;

const PermissionModal = forwardRef(({ userData, reGetData }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
    },
    afterSubmit() {},
  }));

  const [permissions, setPermissions] = useState([]);

  const formHandler = async () => {
    const path = "admin/permissions/assignToUser";
    const body = {
      user: userData?._id,
      permissions,
    };
    try {
      const response = await postApi({ path, body });
      console.log(response);
      successMessage("دسترسی ها با موفقیت ایجاد شدند.");
      reGetData();
      closeModal();
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  const assignRef = useRef();

  const closeModal = () => {
    assignRef.current.afterSubmit();
    setShowModal(false);
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-[1500]  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[300px] sm:w-[800px] py-4 max-h-[360px] overflow-y-scroll bg-white mt-4 shadow-md z-[1501] rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] sm:mr-[-400px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2">
          <h4>{` کاربر ${userData?.name || "-"}`}</h4>
          <PiXFill
            onClick={closeModal}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>
        <div className="flex flex-col gap-2 items-center justify-center py-6">
          <p>
            آیا میخواهید برای کاربر {userData?.name || "-"} دسترسی ایجاد کنید ؟
          </p>
          <AssignPermissionSelect
            ref={assignRef}
            onChange={setPermissions}
            oldPermissions={userData?.permissions || []}
          />
        </div>
        <div className="flex gap-2 justify-end w-full">
          <button
            type="button"
            onClick={closeModal}
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            بازگشت
          </button>
          <button
            onClick={formHandler}
            type="button"
            className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800"
          >
            ایجاد دسترسی
          </button>
        </div>
      </div>
    </>
  );
});
export default PermissionModal;
